import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import {
  AnalyticsService,
  doneIcon,
  ModalService,
  RestApiService,
  searchingIcon,
  UIKitIconRegistry,
  URL_MATCH_REGEX,
} from '@ui-kit';
import { interval, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
// eslint-disable-next-line import/no-unresolved
import { P } from '@ui-kit/ui-kit';
import { pick } from 'lodash-es';
import { Router } from '@angular/router';
import { clearSubscription, validVariant } from '../../../app.helpers';
import { UserService } from '../../service/user.service';
import { AppService } from '../../../app.service';
import { LeanFavourite } from '../../../public/favourites/shortlist.helpers';
import { NotificationService } from '../../service';

@Component({
  selector: 'app-add-home',
  templateUrl: './add-home.component.html',
  styleUrls: ['./add-home.component.scss'],
})
export class AddHomeComponent implements OnInit {
  @Input() data: any;

  addHomeForm: FormGroup;

  favourite: LeanFavourite;

  toggle: Dictionary<boolean> = {};

  email: string;

  subscriptin: P.Dictionary<Subscription> = {};

  analysing: string;

  analysingStep: number = 0;

  analysingSteps = [
    'Warming up geo spacial cartography...',
    'Processing quantum topologhy matrices...',
    'Reconciling structural geometry...',
    'Uploading domicile physiographic data...',
    'Downloading habitational attribute stats...',
  ];

  validVariant = validVariant;

  constructor(
    private app: AppService,
    private router: Router,
    private formBuilder: FormBuilder,
    private user: UserService,
    private restApi: RestApiService,
    private modal: ModalService,
    private analytics: AnalyticsService,
    private notifications: NotificationService,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([doneIcon, searchingIcon]);
  }

  ngOnInit(): void {
    // this.toggle.processing = true;

    const signedIn = this.user.signedIn;

    this.toggle.signedIn = signedIn;
    this.toggle.notSignedIn = !signedIn;

    const url = {
      url: [{ value: this.data?.url, disabled: false },
        [Validators.compose([Validators.required, Validators.pattern(URL_MATCH_REGEX)])]],
    };

    const emailAndTanc = {
      email: [{ value: this.data?.email, disabled: signedIn },
        [Validators.compose([Validators.required, Validators.email])]],
      agree_tanc: [{ value: false, disabled: signedIn },
        Validators.compose([Validators.required, Validators.requiredTrue])],
    };

    const addHomeForm = signedIn
      ? { ...url }
      : { ...url, ...emailAndTanc };

    this.addHomeForm = this.formBuilder.group(addHomeForm);
  }

  /**
   *
   */
  addHomeSubmit(event: Event): void {
    event.preventDefault();

    if (!this.addHomeForm.valid) { return; }

    const favourite = this.addHomeForm.value;

    this.toggle.processing = true;

    const subscription = `${AddHomeComponent.name}-processing`;

    this.subscriptin[subscription] = interval(2400)
      .pipe(map(() => {
        this.analysingStep = this.analysingStep >= (this.analysingSteps.length - 1)
          ? 0
          : this.analysingStep + 1;
        return this.analysingStep;
      }))
      .subscribe((index) => this.analysing = this.analysingSteps[index]);

    if (this.user.signedIn) {
      this.user
        .favourite(favourite)
        .toPromise()
        .then(this.onFavourite.bind(this))
        .catch((error) => this.modal.open(error.message))
        .finally(() => {
          this.toggle.processing = false;

          clearSubscription(subscription, this.subscriptin);
        });
    } else {
      const qualifier = (this.user.current.application as any).qualifier || {};

      const publicEnquiry = {
        ...pick(
          this.user.current,
          [
            'first_name',
            'last_name',
            'residence_type',
            'employment_type',
            'income',
            'income_extra',
            'savings',
            'phone',
            'discovery_source',

            'income_basic',
            'income_bonus',
            'income_overtime',
            'income_commission',

            'self_employment_type',

            'income_net_profit_latest',
            'income_net_profit_previous',

            'income_salary_latest',
            'income_salary_previous',
            'income_dividends_latest',
            'income_dividends_previous',
          ],
        ),
        user_snapshot: { ...this.user.origin },
        ...pick(favourite, ['email', 'agree_tanc', 'url']),
        qualifier,
      };

      this.restApi
        .createPublicEnquiry(publicEnquiry)
        .toPromise()
        .then(this.onUnauthenticatedFavourite.bind(this))
        .catch((error) => this.modal.open(error.message))
        .finally(() => {
          this.email = publicEnquiry.email;

          this.toggle.processing = false;

          clearSubscription(subscription, this.subscriptin);

          this.addHomeForm.reset();
        });
    }
  }

  /**
   *
   */
  openInFavourites(event: MouseEvent | TouchEvent): void {
    let fragment: string;
    switch (this.favourite?.canonicalStatus) {
      case 'Pending':
      case 'Processing':
        fragment = 'pending';
        break;
      case 'Archived':
      case 'Not eligible':
        fragment = 'archive';
        break;
      case 'Eligible':
      default:
        fragment = 'eligible';
        break;
    }

    this.router.navigate([`/favourites/${this.favourite?.id}`], { fragment });

    this.app.event.emit({ type: 'dismiss-add-a-home' });
  }

  close(event?: MouseEvent | TouchEvent): void {
    this.app.event.emit({ type: 'dismiss-add-a-home' });
    // this.modal.closeAll();
  }

  /**
   *
   */
  private onFavourite(favourite: LeanFavourite): void {
    this.favourite = favourite;

    this.analytics.eventTrack({
      data: {
        event: 'http',
        action: 'add_home_success',
        label: 'app_add_home',
        properties: {
          value: '1',
          category: 'external',
          route: this.router.url,
        },
      },
    });

    if (this.user.current?.application?.shortlist?.length === 1) {
      this.app.event.emit({ type: 'trigger-rightmove', data: 'enquiry' });
    }

    this.app.event.emit({ type: 'added-a-home' });

    this.app.event.emit({ type: 'trigger-update' });

    this.notifications.notifyEnquiryStatus(favourite);

    this.router.navigate([`/favourites/${favourite.id}`])
      .then(() => this.close());
  }

  /**
   *
   */
  private onUnauthenticatedFavourite(response: { status: number; message: string; }): void {
    this.favourite = {
      status: 'Processing',
    } as unknown as LeanFavourite;

    this.analytics.eventTrack({
      data: {
        event: 'http',
        action: 'sign_up_success',
        label: 'app_add_home',
        properties: {
          value: '1',
          category: 'app_add_home',
          route: this.router.url,
        },
      },
    });

    this.analytics.eventTrack({
      data: {
        event: 'http',
        action: 'add_home_success',
        label: 'app_add_home',
        properties: {
          value: '1',
          category: 'external',
          route: this.router.url,
        },
      },
    });

    this.app.event.emit({ type: 'trigger-pinterest', data: 'signup' });
    this.app.event.emit({ type: 'trigger-rightmove', data: 'signup' });
    this.app.event.emit({ type: 'trigger-rightmove', data: 'enquiry' });

    this.app.event.emit({ type: 'added-a-home' });
  }
}
